/* eslint-disable */
/** @jsx jsx */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Media from 'react-media';
import { Link } from 'gatsby';
import { Menu, Person, Phone } from '@entrata/portals-common/lib/icons';
import { ModalControl } from '@entrata/portals-common/lib/components';
import MarketingNavModal from './MarketingNavModal';
import insuranceCarrierTypes from 'constants/insuranceCarrierTypes';
import { connect } from 'react-redux';
import { logout } from 'redux/modules/user';
import { MINT } from 'constants/theme';
import styled from '@emotion/styled';
import { jsx, css } from '@emotion/core';
import NavLink from './NavLink';

const StyledUserNav = styled('div')`
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  float: right;
`;

const baseLinkStyle = css`
  display: flex;
  align-items: center;
  font-size: 14px;
  padding: 0 16px;
  text-transform: capitalize;

  svg {
    display: none;
  }

  @media only screen and (min-width: ${769 / 16}em) {
    svg {
      display: inline-block;
      padding-right: 8px;
      vertical-align: middle;
    }
  }
`;

const StyledNavLink = styled(NavLink)`
  height: 100%;
  color: ${({ theme }) => theme.tertiary.light};
  font-family: ${({ theme }) => theme.fonts.soehneBuch};

  ${baseLinkStyle} &:focus {
    outline: none;
  }

  &.active {
    color: ${({ theme }) => theme.tertiary.light};
    position: relative;

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  @media only screen and (min-width: ${769 / 16}em) {
    color: ${({ authenticated, theme }) => (authenticated ? theme.primary.base : theme.tertiary.light)};

    &.active {
      color: ${({ theme }) => theme.primary.base};

      &:after {
        content: '';
        width: 100%;
        height: 4px;
        background-color: ${({ theme }) => theme.primary.base};
        display: block;
        position: absolute;
        bottom: -1px;
        right: 0;
      }
    }
  }
`;

const StyledLink = styled(Link)`
  padding-left: 16px;
  color: ${({ theme }) => theme.tertiary.light};
  font-family: ${({ theme }) => theme.fonts.regular};
  position: relative;
  ${baseLinkStyle} &:after {
    width: 1px;
    height: 24px;
    background-color: ${({ theme }) => theme.primary.medium};
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  @media only screen and (min-width: ${769 / 16}em) {
    color: ${({ theme }) => theme.tertiary.light};
    &:after {
      background-color: ${({ theme }) => theme.gray.medium};
    }
  }
`;
const StyledPhoneLink = styled(StyledNavLink)`
  color: ${({ theme }) => theme.tertiary.light};
  @media only screen and (max-width: ${768 / 16}em) {
    display: none;
  }

  svg {
    color: ${({ theme }) => theme.primary.base};
  }
`;
const StyledButton = styled('button')`
  background: none;
  border: none;
  color: white;
  margin: 0 16px 0 0;
  padding: 0;

  @media only screen and (min-width: ${769 / 16}em) {
    color: ${({ theme }) => theme.text.medium};
  }
`;

const StyledLineDiv = styled('div')`
  background-color: ${({ theme }) => theme.tertiary.light};
  height: 24px;
  width: 1px;
`;

const UserNav = ({ authenticated, logout, username, homebody2WebUrl }) => (
  <StyledUserNav>
    <StyledPhoneLink>
      <Phone size={20} color={MINT} />1 (877) 577 0850
    </StyledPhoneLink>
    {authenticated && (
      <Fragment>
        <StyledNavLink to={'/app/account/'} authenticated={authenticated}>
          <Person size={18} />
          {username}
        </StyledNavLink>
        <StyledLineDiv />
      </Fragment>
    )}
    {authenticated ? (
      <StyledLink to='/' onClick={logout}>
        logout
      </StyledLink>
    ) : (
      <StyledNavLink to={'/login/'} authenticated={authenticated}>
        <Person size={18} />
        Log In
      </StyledNavLink>
    )}
    <Media query={`(max-width: ${768 / 16}em)`}>
      {(match) =>
        match &&
        !authenticated && (
          <ModalControl>
            {({ onClick, ref, ...props }) => (
              <Fragment>
                <StyledButton onClick={onClick} ref={ref}>
                  <Menu size={18} />
                </StyledButton>
                <MarketingNavModal {...props} />
              </Fragment>
            )}
          </ModalControl>
        )
      }
    </Media>
  </StyledUserNav>
);

UserNav.propTypes = {
  authenticated: PropTypes.bool,
  logout: PropTypes.func.isRequired,
  username: PropTypes.string,
  homebody2WebUrl: PropTypes.string,
};

export default connect(
  ({ user }) => ({
    username: user.nameFirst || '',
    homebody2WebUrl: user.homebody2WebUrl,
  }),
  {
    logout,
  },
)(UserNav);
